module.exports = __webpack_public_path__ + "img/MOBILE.c6b0ab8e.svg";